import { adapter } from "@/services/db";
import { suspendAuth, reinstateAuth } from "@/services/ccApi";

export const normPhone = (p) => {
  const d = String(p || "").replace(/\D/g, "").slice(-10);
  return d.length === 10 ? `+91${d}` : null;
};
export const isAccountSuspended = (x) => x?.account_status === "suspended" || x?.suspended === true || x?.status === "suspended";

// kind: "customer" (entityId = users doc id) | "professional" (entityId = professionals doc id).
export async function suspendAccount({ by, kind, entityId, uid, phone, userMessage, internalRemark, prevStatus }) {
  const now = new Date().toISOString();
  const patch = { account_status: "suspended", suspended: true, suspended_at: now, suspended_by: by?.email || null, suspension_user_message: userMessage, updated_at: now };
  if (kind === "professional") await adapter.update("professionals", entityId, { ...patch, status: "suspended", status_before_suspension: prevStatus || "active" });
  else await adapter.update("users", entityId, patch);
  if (kind === "professional" && uid) await adapter.set("users", uid, patch).catch(() => {});
  const ph = normPhone(phone);
  const [auth] = await Promise.all([
    suspendAuth(uid).catch((e) => ({ auth_enforced: false, reason: e.response?.data?.detail || e.message })),
    ph ? adapter.set("suspension_notices", ph, { active: true, message: userMessage, suspended_at: now, uid: uid || null, kind }).catch((e) => console.warn("notice", e.code)) : null,
  ]);
  adapter.add("account_suspensions", {
    action: "suspend", entity_type: kind, entity_id: entityId, uid: uid || null, phone: ph,
    user_message: userMessage, internal_remark: internalRemark, auth_enforced: !!auth.auth_enforced, auth_note: auth.reason || null,
    performed_by: by?.email || null, created_at: now,
  }).catch((e) => console.warn("suspension log", e.code));
  return auth;
}

export async function reinstateAccount({ by, kind, entity, uid, phone, password, internalRemark }) {
  const auth = await reinstateAuth(uid, password); // throws 403 on wrong password
  const now = new Date().toISOString();
  const patch = { account_status: "active", suspended: false, reinstated_at: now, reinstated_by: by?.email || null, suspension_user_message: null, updated_at: now };
  if (kind === "professional") await adapter.update("professionals", entity.id, { ...patch, status: entity.status_before_suspension || "active" });
  else await adapter.update("users", entity.id, patch);
  if (kind === "professional" && uid) await adapter.set("users", uid, patch).catch(() => {});
  const ph = normPhone(phone);
  if (ph) adapter.remove("suspension_notices", ph).catch(() => {});
  adapter.add("account_suspensions", {
    action: "reinstate", entity_type: kind, entity_id: entity.id, uid: uid || null, phone: ph,
    internal_remark: internalRemark || null, auth_enforced: !!auth.auth_enforced, auth_note: auth.reason || null,
    performed_by: by?.email || null, created_at: now,
  }).catch((e) => console.warn("suspension log", e.code));
  return auth;
}
